import { cn } from "~/lib/utils";

interface FieldDisplayProps {
  icon: React.ReactNode;
  children: React.ReactNode;
  onEdit?: () => void;
  canEdit?: boolean;
  href?: string;
  target?: string;
  className?: string;
}

export function FieldDisplay({ icon, children, onEdit, canEdit, href, target, className }: FieldDisplayProps) {
  const textClass = cn(
    className ?? "text-sm text-foreground truncate",
    canEdit && "group-hover:text-primary transition-colors",
  );

  const content =
    href && !canEdit ? (
      <a
        href={href}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
        className={textClass}
      >
        {children}
      </a>
    ) : (
      <span className={textClass}>{children}</span>
    );

  // Simple layout when no icon
  if (!icon) {
    return (
      <div className={cn("group", canEdit && "cursor-pointer")} onClick={() => canEdit && onEdit?.()}>
        {content}
      </div>
    );
  }

  return (
    <div
      className={cn("flex items-center gap-2 text-sm group", canEdit && "cursor-pointer")}
      onClick={() => canEdit && onEdit?.()}
    >
      <span className="text-muted-foreground shrink-0">{icon}</span>
      {content}
    </div>
  );
}
